import React, { useEffect, useState } from 'react';

export default function NewLabel (props) {
  return (
    <span className="phif_label_new"><i className="hide">신작</i></span>
  );
}